
// depends on global PIXI and TWEEN

/**
 * @file linebillet.js
 * @desc This module contains LineBillet class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

(/** @lends <global> */function (global) {
    'use strict';

    /**
     * Constructs line billet object.
     * @class
     * @constructor
     * @param {String} activeBilletFilename Active billet filename
     * @param {String} [inactiveBilletFilename] Inactive billet filename
     * @name LineBillet
     * @classdesc This is a GUI component.
     * @extends {PIXI.Container}
     * @tutorial 1.7-adding-lines-frames-billets
     * */
    var LineBillet = function (activeBilletFilename, inactiveBilletFilename) {
        PIXI.Container.call(this);

        this._inactiveBillet = inactiveBilletFilename ? new PIXI.Sprite(PIXI.utils.TextureCache[inactiveBilletFilename]) : null;
        if (this._inactiveBillet) {
            this.addChild(this._inactiveBillet);
        }

        this._activeBillet = new PIXI.Sprite(PIXI.utils.TextureCache[activeBilletFilename]);
        this.addChild(this._activeBillet);

        this._activeBillet.alpha = 0;
    };

    LineBillet.prototype = Object.create(PIXI.Container.prototype);

    LineBillet.prototype.constructor = LineBillet;

    /**
     * Shows inactive billet.
     * @memberOf LineBillet
     * */
    LineBillet.prototype.showOffBillet = function () {
        if (this._inactiveBillet) {
            this._inactiveBillet.alpha = 1;
        }
    };

    /**
     * Hides inactive billet.
     * @memberOf LineBillet
     * */
    LineBillet.prototype.hideOffBillet = function () {
        if (this._inactiveBillet) {
            this._inactiveBillet.alpha = 0;
        }
    };
    
    /**
     * Shows active billet.
     * @memberOf LineBillet
     * */
    LineBillet.prototype.showOnBillet = function () {
        this._activeBillet.alpha = 1;
        this.hideOffBillet();
    };
    
    /**
     * Hides active billet.
     * @memberOf LineBillet
     * */
    LineBillet.prototype.hideOnBillet = function () {
        this._activeBillet.alpha = 0;
        this.showOffBillet();
    };
    
    /**
     * Check if active billet is visible.
     * @returns {Boolean} True if active billet is visible otherwise not
     * @memberOf LineBillet
     * */
    LineBillet.prototype.activeBilletIsVisible = function () {
        return this._activeBillet.alpha > 0;
    };

    /**
     * Fades in active billet
     * @param {Number} [time] Time in milliseconds
     * @memberOf LineBillet
     * */
    LineBillet.prototype.fadeIn = function (time) {

        time = time || 200; // ms

        this.reset();

        var self = this;

        //this._activeBillet.alpha = 0;
        this.billetsIn = new TWEEN.Tween(this._activeBillet)
            .to({alpha: 1}, time)
            .onStop(function () {
                self.hideOffBillet();
            })
            .onComplete(function () {
                self.hideOffBillet();
            })
            .start();
    };

    /**
     * Fades out active billet
     * @param {Number} [time] Time in milliseconds
     * @memberOf LineBillet
     * */
    LineBillet.prototype.fadeOut = function (time) {

        time = time || 200; // ms

        this.reset();

        this.showOffBillet();

        var self = this;
        //this._activeBillet.alpha = 1;
        this.billetsOut = new TWEEN.Tween(this._activeBillet)
            .to({alpha: 0}, time)
            .onStop(function () {
                self._activeBillet.alpha = 0;
            })
            .onComplete(function () {
                self._activeBillet.alpha = 0;
            })
            .start();
    };
    
    LineBillet.prototype.reset = function() {
        if (this.billetsIn) this.billetsIn.stop();
        if (this.billetsOut) this.billetsOut.stop();
    };

    global.LineBillet = LineBillet;
}(typeof module === 'object' && module.exports || this));



// WEBPACK FOOTER //
// ./src/library/linebillet.js